import { Application } from "@hotwired/stimulus";

const application = Application.start();
application.debug = false;
window.Stimulus = application;

import ApplyToAllController from "./apply_to_all_controller";
import AutosubmitController from "./autosubmit_controller";
import BootstrapModalController from "./bootstrap_modal_controller";
import CarReportFormController from "./car_report_form_controller";
import CarDefaultsController from "./car_defaults_controller";
import DetailsToggleController from "./details_toggle_controller";
import DismissableController from "./dismissable_controller";
import EventListController from "./event_list_controller";
import ExtraDataController from "./extra_data_controller";
import LevelFilterController from "./level_filter_controller";
import LedgerMotionController from "./ledger_motion_controller";
import LightboxController from "./lightbox_controller";
import ListAppendController from "./list_append_controller";
import MarkReadController from "./mark_read_controller";
import MiaFieldController from "./mia_field_controller";
import PaymentFormController from "./payment_form_controller";
import PrintController from "./print_controller";
import PeopleFilterController from "./people_filter_controller";
import RebalanceController from "./rebalance_controller";
import RegistrationFormController from "./registration_form_controller";
import RequiredMessageController from "./required_message_controller";
import TabHashController from "./tab_hash_controller";
import TemplateInsertController from "./template_insert_controller";
import TimetableController from "./timetable_controller";
import TomSelectController from "./tom_select_controller";

application.register("apply-to-all", ApplyToAllController);
application.register("autosubmit", AutosubmitController);
application.register("bootstrap-modal", BootstrapModalController);
application.register("car-defaults", CarDefaultsController);
application.register("car-report-form", CarReportFormController);
application.register("details-toggle", DetailsToggleController);
application.register("dismissable", DismissableController);
application.register("event-list", EventListController);
application.register("extra-data", ExtraDataController);
application.register("level-filter", LevelFilterController);
application.register("ledger-motion", LedgerMotionController);
application.register("lightbox", LightboxController);
application.register("list-append", ListAppendController);
application.register("mark-read", MarkReadController);
application.register("mia-field", MiaFieldController);
application.register("payment-form", PaymentFormController);
application.register("print", PrintController);
application.register("people-filter", PeopleFilterController);
application.register("rebalance", RebalanceController);
application.register("registration-form", RegistrationFormController);
application.register("required-message", RequiredMessageController);
application.register("tab-hash", TabHashController);
application.register("template-insert", TemplateInsertController);
application.register("timetable", TimetableController);
application.register("tom-select", TomSelectController);

export { application };
